import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import {
    AppFooter,
    AppHeader,
    AppSidebar,
    AppSidebarFooter,
    AppSidebarForm,
    AppSidebarHeader,
    AppSidebarMinimizer,
    AppSidebarNav,
} from '@coreui/react';

import Footer from './Footer';
import Header from './Header';

import agent from '../agent';

import routes from '../config/routes';

import {
    HOME_LOAD_NAVIGATION
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.Home,
    appName: state.common.appName,
    token: state.common.token,
    roles: state.common.roles
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) =>
        dispatch({ type: HOME_LOAD_NAVIGATION, payload }),
});

export class Home extends Component {
    constructor(props) {
        super(props);

        this.loadNavigation = this.loadNavigation.bind(this);
    }

    componentWillMount() {
        this.loadNavigation();
    }

    loadNavigation() {
        const payload = {
            navgroupid: 10,
            roles: this.props.roles
        }
        const navigationPromise = this.props.token ? agent.NavTree.postget(payload) : null;

        Promise.all([navigationPromise]).then((payload) => {
            this.props.onLoad(payload);

        });
    }

    render() {
        const navigationSection = this.props.navigation ? (<AppSidebarNav navConfig={this.props.navigation} {...this.props} />) : (<div className="p-4">Loading nav...</div>);

        return (
            <div className="app">
                <AppHeader fixed>
                    <Header />
                </AppHeader>
                <div className="app-body">
                    <AppSidebar fixed display="lg">
                        <AppSidebarHeader />
                        <AppSidebarForm />
                        {navigationSection}
                        <AppSidebarFooter />
                        <AppSidebarMinimizer />
                    </AppSidebar>
                    <Switch>
                        {routes.map((route, idx) => {
                            return route.component ? (
                                <Route key={idx} path={route.path} exact={route.exact} name={route.name}
                                    render={props => (<route.component {...props} />)}
                                />
                            ) : (null);
                        },
                        )}
                        <Redirect from="/" to="/dashboard" />
                    </Switch>
                </div>
                <AppFooter>
                    <Footer />
                </AppFooter>
            </div >
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js